import React from "react";
import { NextSeo } from "next-seo";
import { defaultImages, defaultDescription } from "./seoConfig";
import { useRouter } from "next/router";

export default function TemplateSEO({ urlPath, title, description, images }) {
    const router = useRouter();

    const desc = description ? description : `${title} | ${defaultDescription}`;
    const path = urlPath ? urlPath : router.asPath.slice(1);

    return (
        <>
            <NextSeo
                title={title}
                description={desc}
                canonical={`https://www.inuua.net/${path}`}
                openGraph={{
                    type: "website",
                    locale: "en_GB",
                    url: `https://www.inuua.net/${path}`,
                    site_name: "Inuua Tujenge",
                    title: title,
                    description: desc,
                    images: images
                        ? // (bug) include them two times because if we don't the default image on <DefaultSeo/> will be shown
                          images.concat(images)
                        : defaultImages,
                }}
            />
        </>
    );
}
